module.exports = __webpack_public_path__ + "img/00050.60b550d8.webp";